import { Component, Inject, OnInit } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { HoveredIncadea } from 'src/services/incadea/incadea-interfaces/HoveredData.interface';

import { HelperService } from 'src/services/helperService';
import { GetAppointmentCreate } from 'src/services/incadea/incadea-services/getAppointmentCreate.service';
import { IncadeaBookingService } from 'src/services/api-services/IncadeaBooking.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
    selector: 'app-i-cancel-appointment.dialog',
    templateUrl: './i-cancel-appointment.dialog.html',
    styleUrls: ['./i-cancel-appointment.dialog.sass'],
    providers: [TitleCasePipe],
    standalone: false
})
export class ICancelAppointmentDialog implements OnInit {
  iAppointmentSchedule = '';
  deleteAppointmentPreventiveMessage: string = ''
  appointmentcancellation: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ICancelAppointmentDialog>,
    @Inject(MAT_DIALOG_DATA) public appointment: HoveredIncadea,
  
    public titleCasePipe: TitleCasePipe,
    public getAppointment: GetAppointmentCreate,
    public cancelAppointmentSchedule: IncadeaBookingService,
    public helperService: HelperService,
    private translate: TranslateService,
  ) {
    

    this.iAppointmentSchedule = this.titleCasePipe.transform(
      `${ new Date(appointment.dataItem.Start).toLocaleDateString(this.helperService.user.language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
         ${moment(appointment.dataItem.Start).format('h:mm a')} - ${moment(appointment.dataItem.End).format('h:mm A')}`);       
  }

  onCancelAppointment() {
    this.appointmentcancellation=true
    this.getAppointment.cancelAppointmnet(this.appointment.dataItem.Token!, this.appointment.dataItem.CompanyId, this.appointment.dataItem.AppointmentId,this.helperService.user.incadeaBackendCode! ).subscribe(
      (response)=>{
        if(response.status === 200){
          this.cancelAppointmentSchedule.cancelAppointment(this.appointment.dataItem.AppointmentId).subscribe(
            {
              next: (response) => {
                if (response.code === 200) {
          
         
                if (response.message=== "Deleted successfully") { 
                  const cancelSuccesss = this.translate.instant('CancelSuccessMessage', {
                    serviceName: this.appointment.dataItem.Services[0].ServiceName
                  })
              
                  this.helperService.showAlert =true
                  this.helperService.typeAlert ="success"
                  this.helperService.messageAlert =cancelSuccesss
                  setTimeout(() => {
                    this.helperService.showAlert =false
                    }, 7000)
                  this.appointmentcancellation=false

                  this.helperService.showAlert =true
          
                  this.dialogRef.close(true);
                }
              }
              },
            }
          )
        }
        if(response.status=== 400 || response.status=== 500){
          const cancelFailed = this.translate.instant('cancelFailedMsg')
          this.appointmentcancellation=false
          this.helperService.showAlert =true
            this.helperService.typeAlert ="warning"
            this.helperService.messageAlert =cancelFailed
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
       
        }
      }
      );
  }

  ngOnInit(): void {
  }

}
